import { Component, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    // selector: '.m-grid__item.m-grid__item--fluid.m-grid.m-grid--ver-desktop.m-grid--desktop.m-body.m-page__container',
    templateUrl: './public.component.html',
    styleUrls: ['public.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterOutlet],
})
export class PublicComponent {}
